import ApiUrls from '../config/ApiUrls';
import { replaceByObject } from '../utils/Urls';
import API from './Api';
import {
  LoanAccountsCreateApiRequest,
  LoanAccountsUpdateApiRequest,
} from '../data/models/LoanAccounts';
import { DateTime } from 'luxon';

export type LoanAccountsApiResponse = {
  id: number;
  created: DateTime;
  org1: {
    id: number;
    accountCode: string;
    ncExternalId?: string;
    isLender: boolean;
  };
  org2: {
    id: number;
    accountCode: string;
    ncExternalId?: string;
    isLender: boolean;
  };
  name: string;
  isRecharger: boolean;
  isBrag: boolean;
};

export class LoanAccountsApi extends API {
  static async getLoanAccount(
    groupId: number,
    loanAccountId: number
  ): Promise<LoanAccountsApiResponse> {
    const response = await API.get(
      replaceByObject(ApiUrls.LoanAccount, { groupId, loanAccountId })
    );
    return response.data;
  }

  static async create(
    groupId: number,
    data: LoanAccountsCreateApiRequest
  ): Promise<LoanAccountsApiResponse> {
    const response = await API.post(
      replaceByObject(ApiUrls.LoanAccounts, { groupId }),
      data
    );
    return response.data;
  }

  static async update(
    groupId: number,
    loanAccountId: number,
    data: LoanAccountsUpdateApiRequest
  ): Promise<LoanAccountsApiResponse> {
    const response = await API.put(
      replaceByObject(ApiUrls.LoanAccount, { groupId, loanAccountId }),
      data
    );
    return response.data;
  }

  static async remove(
    groupId: number,
    loanAccountId: number
  ): Promise<LoanAccountsApiResponse> {
    const response = await API.delete(
      replaceByObject(ApiUrls.LoanAccount, { groupId, loanAccountId })
    );
    return response.data;
  }
}
